
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 31 31","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.473 29.406c-2.79 0-5.518-.829-7.838-2.382a14.126 14.126 0 01-5.196-6.343A14.156 14.156 0 015.5 5.279a14.083 14.083 0 0115.375-3.061 14.112 14.112 0 016.33 5.207 14.151 14.151 0 012.376 7.853 14.161 14.161 0 01-4.138 9.986 14.11 14.11 0 01-9.97 4.142zm0-25.911c-2.326 0-4.6.69-6.533 1.983a11.774 11.774 0 00-4.332 5.285A11.799 11.799 0 007.152 23.6a11.738 11.738 0 0012.813 2.558c2.148-.891 3.985-2.4 5.278-4.337a11.794 11.794 0 001.984-6.543 11.802 11.802 0 00-3.445-8.327 11.759 11.759 0 00-8.31-3.456z"}}),_c('path',{attrs:{"d":"M11.36 14.099c.974 0 1.764-.79 1.764-1.766 0-.975-.79-1.766-1.763-1.766-.974 0-1.763.79-1.763 1.766 0 .975.79 1.766 1.763 1.766zM19.589 14.099c.973 0 1.763-.79 1.763-1.766 0-.975-.79-1.766-1.763-1.766-.974 0-1.763.79-1.763 1.766 0 .975.79 1.766 1.763 1.766zM15.473 17.631a8.244 8.244 0 017.118 4.12 1.175 1.175 0 01-1.731 1.52 1.173 1.173 0 01-.302-.346 5.869 5.869 0 00-5.081-2.943 5.855 5.855 0 00-5.082 2.943 1.176 1.176 0 11-2.036-1.174 8.244 8.244 0 017.114-4.12z"}})])
          )
        }
      }
    